import { bootstrapApplication, createApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { createCustomElement } from '@angular/elements';
import { PaywallMainComponent } from './app/components/paywall-main/paywall-main.component';
import { inject, Injector } from '@angular/core';

// (async () => {
//   const appElement = createCustomElement(PaywallMainComponent, { injector: new Injector() });
//   customElements.define('paywall-main', appElement);
// })();

// bootstrapApplication(AppComponent, appConfig)
//   .then((ref) => {
//     debugger;
//     const injector = ref.injector;
//     const appElement = createCustomElement(PaywallMainComponent, { injector });
//     customElements.define('paywall-main', appElement);
//   })
//   .catch((err) => console.error(err));

createApplication(appConfig).then((ref) => {
  const injector = ref.injector;
  const appElement = createCustomElement(PaywallMainComponent, { injector });
  customElements.define('paywall-main', appElement);
  if (document.querySelector('app-root')) {
    bootstrapApplication(AppComponent, appConfig);
  }
}).catch((err) => console.error(err));
